import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { containerExists } from './rsa-ad-strength-suggestion-helper';

export class AIGenAssetContextualAttribute extends React.Component {
  static defaultProps = {
    container: $(document.body),
    improveMMAOption: {},
    newI18n: {
      getString: _.noop,
    },
  };

  getDisplayPosition(target, container) {
    const $target = $(target);
    const targetOffset = $target.offset();
    const containerOffset = container.offset();

    return {
      top: (targetOffset.top - containerOffset.top) - ($target.outerHeight() - 35),
      left: targetOffset.left - containerOffset.left - 103,
    };
  }

  render() {
    const {
      container, i18n, target, isAIGeneratedAsset, improveMMAOption, newI18n,
    } = this.props;

    const position = this.getDisplayPosition(target, container);

    const containerStyle = {
      display: 'block',
      left: `${position.left}px`,
      top: `${position.top}px`,
      width: '220px',
    };

    let content = i18n.getString('Ad_Strength_Improve_RSA_Contextual_Content');

    if (improveMMAOption && improveMMAOption.type) {
      if (improveMMAOption.type === 'Text') {
        content = newI18n.getString(_TL_('We\'ve made these recommendations based on text generated from your websites.'));
      } else if (improveMMAOption.type === 'Image') {
        content = newI18n.getString(_TL_('Our recommendations are based on the images generated from your websites.'));
      }
    } else if (isAIGeneratedAsset) {
      content = i18n.getString('Ad_Strength_RSA_AI_Generated_Asset_Contextual_Content');
    }

    return (
      <div id="contextual-attribute" role="tooltip" className="fade in bingads-webui-react-callout-popover popover bottom" style={containerStyle}>
        <div className="arrow" />
        <div className="popover-content">
          <div className="ba-backbone-instance-wrapper">
            <div>
              <div className="popover-paged-content__body">
                <div className="popover-content">
                  <div className="contextual-tooltip-container">
                    <div className="contextual-content">
                      <span className="line-height-normal">{content}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="popover-paged-content__pager" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AIGenAssetContextualAttribute.propTypes = {
  target: PropTypes.shape({}).isRequired,
  container: PropTypes.shape({ offset: PropTypes.func }),
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  isAIGeneratedAsset: PropTypes.bool.isRequired,
  improveMMAOption: PropTypes.shape({
    type: PropTypes.string,
  }),
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }),
};

/*
 * Attaches event listeners to on the light bulb icon to show contextual attribute
 */
export const attachAIGenAssetContextualAttribute = ({
  element,
  i18n,
  isAIGeneratedAsset,
  improveMMAOption,
  newI18n,
}) => {
  if (!containerExists($('.rsa-ai-generated-asset-container'))) {
    const aiGendAssetCAContainer = $('<div class="rsa-ai-generated-asset-container"/>');
    aiGendAssetCAContainer.appendTo($(document.body));
  }

  element.on('mouseenter mouseout keydown', (event) => {
    const { key, target, type } = event;
    const existingContextualAttributeContainer = $('.rsa-ai-generated-asset-container');
    if (containerExists(existingContextualAttributeContainer)) {
      if (type === 'mouseenter' || (type === 'keydown' && key === 'Enter')) {
        // Hide previous contextual attribute pop-up
        ReactDOM.unmountComponentAtNode(_.first(existingContextualAttributeContainer));

        // Show current contextual attribute pop-up
        const contextualAttributeContainer = _.first(existingContextualAttributeContainer);
        ReactDOM.render(React.createElement(AIGenAssetContextualAttribute, {
          target,
          i18n,
          isAIGeneratedAsset,
          improveMMAOption,
          newI18n,
        }), contextualAttributeContainer);
      } else if (type === 'mouseout') {
        // Hide current contextual attribute pop-up
        ReactDOM.unmountComponentAtNode(_.first(existingContextualAttributeContainer));
      }
    }
  });
};
